import {handleAction} from 'uix/actions'
import {setContextHelpOn, navigateHelp} from './actions'

import log from 'uix/logging'

export const meta = [
  handleAction(
    setContextHelpOn,
    ({contextHelp, ...meta}, {payload}) => {
      return {
        ...meta,
        contextHelp: {...contextHelp, on: payload},
      }
    },
    {contextHelp: {on: false, navigation: {}}}
  ),
  handleAction(navigateHelp, ({contextHelp, ...meta}, {payload}) => {
    return {
      ...meta,
      contextHelp: {
        ...contextHelp,
        navigation: {...contextHelp.navigation, [payload.wikiIdent]: payload.navIdent},
      },
    }
  }),
]
